module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_suns_color_vertical-05c9b6d521c5aab9463618f098e1d77a.svg";